import React, { useState, useEffect } from 'react';
import '../styles/landing.css';
import Header from '../components/Header';
import Banner from '../components/Banner';
import Intro from '../components/Intro';
import Releases from '../components/Releases';
import Merch from '../components/Merch';
import Artists from '../components/Artists';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

function LandingPage() {
  return (
    <div className="landing-page">
      <Header />
      <Banner />
      <main>
        <Intro />
        <Releases />
        <Merch />
        <Artists />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;

